export default __webpack_public_path__ + "static/header-00353589d2094d9eeca1501786d23e60.png";